(function() {
  define('bazemont/newsletter/editorial/delete',['angular'], function() {
    'use strict';
    return angular.module('bazemontNewsletterEditorialDelete', []).component('bazemontNewsletterEditorialDelete', {
      template: '<a href="" ng-click="$ctrl.openDeleteModal()">Supprimer</a>',
      bindings: {
        url: '@'
      },
      controller: [
        'TlhConfirmModalService', '$window', function(TlhConfirmModalService, $window) {
          var vm;
          vm = this;
          vm.openDeleteModal = function() {
            var message;
            message = '<p class="text-center">Êtes-vous sûr(e) de vouloir supprimer cette newsletter ?</p>';
            return TlhConfirmModalService.open(message).result.then(function(result) {
              if (result.confirm) {
                return $window.location.href = vm.url;
              }
            });
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=delete.js.map
;
